//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import { mapActions } from 'vuex';

export default {
  props: {
    itemText: { type: Function, default: (e) => e.name },
    itemValue: { type: Function, default: (e) => e.id },
    clearable: { type: Boolean, default: true },
    hideDetails: { type: Boolean, default: false },
    className: { type: String, default: '' },
    value: { type: [Array, Object, Number, Boolean, String], default: () => [] },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    label: { type: String, default: '' },
    width: { type: String, default: '' },
  },

  data() {
    return {
      searchString: '',
      loading: false,
      items: [],
    };
  },

  computed: {
    style() {
      return {
        width: this.width,
      };
    },

    getNoDataText() {
      if (!this.searchString && !this.loading) {
        return this.$t('Enter device name to search');
      }

      if (this.loading) {
        return this.$t('Looking for such a device');
      }

      if (!this.loading && this.items.length === 0) {
        return this.$t('We did not find such device');
      }

      return '';
    },

    searchResult() {
      const { items } = this;
      return items;
    },
  },

  watch: {
    searchString(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateSearchString();
      }
    },
  },

  methods: {
    ...mapActions('userDevices', ['searching']),

    input(value) {
      this.$emit('input', value);
    },

    updateSearchString() {
      const { searchString } = this;
      if (!searchString) return;
      this.loading = true;
      this.loadDevices();
    },

    loadDevices: _.debounce(async function load() {
      const userId = this.$route.params.id;
      const { searchString } = this;
      const { items } = await this.searching({ searchString, userId });
      this.items = [...this.items, ...items];
      this.loading = false;
    }, 500),
  },
};
